var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNameIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.49 58.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b4ee7a7a-098e-4c90-836f-0d36f777d3e3,.f182326d-6cc2-496a-a14a-f51bc87f38d3{fill:none;stroke:#1a1a1a;stroke-miterlimit:10;}.b4ee7a7a-098e-4c90-836f-0d36f777d3e3{stroke-width:1.44px;}.f182326d-6cc2-496a-a14a-f51bc87f38d3{stroke-width:1.27px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ed2d23f8-efca-4af2-a620-0f42a4c06713",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b26a83c9-a04f-42f9-bd21-ea1cd520c076",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b4ee7a7a-098e-4c90-836f-0d36f777d3e3",
    d: "M29.24,28.4c5.05,0,6.25-4,6.25-7.31a6.25,6.25,0,0,0-12.5,0c0,3.34,1.66,7.31,6.25,7.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b4ee7a7a-098e-4c90-836f-0d36f777d3e3",
    d: "M30.11,29.24H28.37c-3.42,0-8.56,3-8.56,6.78s-1.16,6.78,2.26,6.78H36.41c3.43,0,2.27-3,2.27-6.78s-5.14-6.78-8.57-6.78Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f182326d-6cc2-496a-a14a-f51bc87f38d3",
    cx: 29.24,
    cy: 29.24,
    r: 28.61
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameIcon);
export default __webpack_public_path__ + "static/media/name_icon.e2c596aedaf58bd574179a30d5ad07de.svg";
export { ForwardRef as ReactComponent };